<template>
    <form class="form w-100" id="kt_kyc_form" @submit.prevent="submitResponse">
        <Card class="card p-5" :title="nps?.title">
          <template #cardToolbar>
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm" btn-text="back" @click="backList"></Button>
          </template>
          <div class="modal-body">
              <Card class="card p-5 justify-ceontent-center align-items-center">
                  <Label labelClass="form-label fs-3 fw-bolder" :label="nps?.nps_description" :required="true"/>
                  <NpsInput v-if="nps.icon == ICONS.EMOJI" :type="ICONS.EMOJI"/>
                  <NpsInput v-if="nps.icon == ICONS.STAR" :type="ICONS.STAR"/>
              </Card>
              <br>
              <FormField
                  v-for="field in nps?.form?.fields"
                  :key="field.id"
                  :form-data="field"
                  :form-errors="formErrors"
                  :withId="false"
                  v-model="formData" /> 
          </div>
        </Card>
    </form>
</template>
  
<script setup>
  import {computed, onMounted, ref, watch} from "vue";
  import {useStore} from "vuex";
  import {useRouter, useRoute} from "vue-router";
  import Card from "@/components/Card.vue";
  import FormField from "@/components/Form/FormField.vue";
  import { useNpsIcon } from "../../composables/useNpsIcon";
  import { reactive } from "vue";
  import Label from "@/components/Form/Label.vue";
  import NpsInput from "../../components/Inputs/NpsInput.vue";
  import Button from "@/components/Button.vue";
  
  const route = useRoute()
  const router = useRouter()
  
  const store = useStore()
  const { ICONS } = useNpsIcon()
  
  const getting = ref(false)
  const loading = ref(false)

  const nps = ref({})
  const formData = reactive({})
  const formErrors = ref({})
  
  const company = computed(() => store.getters['offices/getSelectedCompany'])
  
  watch(() => route.params.nps, () => {
    if(route.params.nps){
      loadNps()
    }
  })

  watch(() => route.query.tab, (value) => {
    if(value == 'tab-nps' && route.params.nps) {
      loadNps()
    }
  })
  
  const loadNps= () => {
    getting.value = true
    store.dispatch('eventNps/getNps', route.params.nps).then((resp) => {
      nps.value = resp.data.data
      initForm(resp.data.data)
    })
    .finally(() => getting.value = false)
  }
  
  function submitResponse(data){
    loading.value = true
    store.dispatch('', {...data, society_id: company?.value.id, name: data?.title})
        .then(res => {
          window.toastr['success'](i18n.global.t("notification.nps_response_submited"))
          
        })
        .catch((err) => {
        })
        .finally(() => loading.value = false)
  }

  
  function initForm(nps){
    
  }

  const backList = () => {
    router.push({ name: 'events-nps-index', params: { id: route.params.id }, query: { tab: route.query.tab || 'tab-nps' } });
  }
  
  onMounted(() => {
    if(route.params.nps && route.query.tab == 'tab-nps'){
      loadNps()
    }
  })
  
  </script>
  
  <style scoped>
  .password-input {
    position: relative;
  }
  
  .toggle-password {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  #eye-icon {
    font-size: 1.2em;
  }
  </style>
  